import { useState } from 'react'
import { F0Box, F0Button, F0Dialog, F0Heading, F0OneIcon, F0Text } from '@factorialco/f0-react'
import { useVoiceSession } from 'modules/ai_voice/providers/voiceSession'
import { useFeatures } from 'modules/core/hooks/useFeatures'
import { useDemoTourTasks } from 'modules/get_started/hooks/useDemoTourTasks'
import DemoTourPopover, { getCompletedTasks } from 'modules/get_started/components/DemoTourPopover'

type View = 'dialog' | 'popover' | 'hidden'

const DemoAiTours = () => {
  const [view, setView] = useState<View>('dialog')
  const completedTasks = getCompletedTasks()
  const { setParams, startSession } = useVoiceSession()
  const { has_show_ai_demo_tours: showAiDemoTours } = useFeatures(['show_ai_demo_tours'])
  const { tasks, loading } = useDemoTourTasks({ skip: !showAiDemoTours })

  const handleGetStarted = () => {
    setParams({ agent: 'demo', task: 'welcome' })
    startSession()
    setView('popover')
  }

  const handleCloseDialog = () => {
    setView('popover')
  }

  const handleStartTask = (taskKey: string) => {
    setParams({ agent: 'demo', task: taskKey })
    startSession()
  }

  const handleClosePopover = () => {
    setView('hidden')
  }

  if (!showAiDemoTours || loading || tasks.length === 0) return null

  return (
    <>
      <F0Dialog isOpen={view === 'dialog'} onClose={handleCloseDialog} width="sm">
        <F0Box position="relative" paddingX="xl" paddingY="xl">
          <F0Box display="flex" flexDirection="column" alignItems="center" gap="xl">
            <F0Box display="flex" flexDirection="row" alignItems="center" gap="md">
              <F0OneIcon size="md" />
              <F0Text content="Take a tour with One" variant="label" />
            </F0Box>
            <F0Heading as="h2" variant="heading-large" content="Welcome to Factorial" />
            <F0Text
              content="Discover how Factorial can transform your HR processes. Let our AI assistant guide you through the key features."
              variant="body"
              align="center"
            />
            <F0Button
              variant="primary"
              label="Get started guided tour"
              onClick={handleGetStarted}
            />
          </F0Box>
        </F0Box>
      </F0Dialog>

      {view === 'popover' && (
        <DemoTourPopover
          tasks={tasks}
          completedTasks={completedTasks}
          onStartTask={handleStartTask}
          onClose={handleClosePopover}
        />
      )}
    </>
  )
}

export default DemoAiTours
